<template>
  <Header v-if="this.headerActive" @updateBerechtigungen="this.berechtigungen = $event"/>
  <router-view :key="$route.fullPath" :berechtigungen="this.berechtigungen"/>
  <FooterNavigation v-if="this.footerActive"/>
</template>

<script>
// Importiere den WebSocket-Client aus der Datei
import socket from './websocket.js';
import Swal from 'sweetalert2';
import FooterNavigation from './components/Home/FooterNavigation.vue';
import Header from './components/Header.vue';

export default {
  name: 'App',
  components: {
    FooterNavigation,
    Header
  },
  data() {
    return {
      connected: false,
      socket: null,
      fullscreen: null,

      headerActive: false,
      footerActive: false,
      berechtigungen: []
    };
  },
  beforeMount(){
    //this.requestFullscreen();
  },
  methods: {
    checkHeaderActive(name){
      switch (name) {
        case 'login':
        case 'ueberDieApp':
        case 'datenschutz':
        case 'hydranten':
        case 'hilfeimwald':
        case 'sammelpunkte':
        case 'kassensystem':
          return false;
          break;
      
        default:
          console.log(true);
          return true;
          break;
      }
    },
    checkFooterActive(name){
      switch (name) {
        case 'login':
        case 'ueberDieApp':
        case 'datenschutz':
        case 'benutzerverwaltung':
        case 'fahrzeugverwaltung':
        case 'geraeteverwaltung':
        case 'defaultwerte':
        case 'hydranten':
        case 'hilfeimwald':
        case 'sammelpunkte':
        case 'feuerwehrverwaltung':
        case 'gefahrgut':
        case 'eurorescue':
        case 'funk':
        case 'what3words':
        case 'wea-nis':
        case 'brandmeldeanlage':
        case 'kassensystem':
          return false;
          break;
      
        default:
          console.log(true);
          return true;
          break;
      }
    },
    enterFullscreen(element) {
      if(element.requestFullscreen) {
        element.requestFullscreen();
      } else if(element.msRequestFullscreen) {      // for IE11 (remove June 15, 2022)
        element.msRequestFullscreen();
      } else if(element.webkitRequestFullscreen) {  // iOS Safari
        element.webkitRequestFullscreen();
      }
    },
    isBrowser(){
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Überprüfen auf gängige Browser-Strings
      if ((userAgent.includes("Chrome") || userAgent.includes("Safari") || userAgent.includes("Firefox") || userAgent.includes("Edge")) && typeof window.cordova == "undefined") {
          return true;  // Wahrscheinlich ein Browser
      } else {
          return false;  // Möglicherweise eine App
      }
    },
    requestFullscreen(){
      if(this.isBrowser()){
        Swal.fire({
          title: "Anwendung im Vollbild starten",
          showDenyButton: true,
          confirmButtonText: "Ja",
          denyButtonText: `Nein`
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.enterFullscreen(document.documentElement)
            this.fullscreen = true;
          } else if (result.isDenied) {
            this.fullscreen = false;
          }
        });
      }
    }
  },
  created() {
    const router = createRouter({
      history: createWebHistory(),
      routes: [
        { path: '/', redirect: '/home' },
        { path: '/home', component: Home },
      ],
    });
  },
  mounted() {
    // WebSocket-Verbindung herstellen
    if(this.connected == false){
    this.socket = socket;
    //this.socket = new WebSocket('wss://feuerwehr-server.org:5000');
    //this.socket = new WebSocket('wss://feuerwehr-server.org/ws');


    // Beispiel: Verbindungszustand überwachen
    this.socket.onopen = () => {
      console.log('WebSocket-Verbindung geöffnet.');
      this.connected = true;

      // Beispiel: Nachricht senden, wenn die Verbindung hergestellt ist
      this.socket.send('Hallo Server!');
    };

    this.socket.onclose = () => {
      console.log('WebSocket-Verbindung geschlossen.');
      this.connected = false;
    };

    this.socket.onerror = (error) => {
      console.error('WebSocket-Fehler:', error);
    };

    this.socket.onmessage = (event) => {
      console.log('Nachricht erhalten:', event.data);
      // Hier kannst du die empfangenen Daten weiterverarbeiten
    };
  }
    //this.requestFullscreen();
  },
  watch: {
    $route(to, from){
      if (!document.fullscreenElement && this.fullscreen == null){
        //this.requestFullscreen();
      }
      this.headerActive = this.checkHeaderActive(to.name);
      this.footerActive = this.checkFooterActive(to.name);
    }
  },
  created(){
    this.headerActive = this.checkHeaderActive(this.$route.name);
    this.footerActive = this.checkFooterActive(this.$route.name);
  }
};
</script>

<style lang="scss">
html {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  //background-color: #C00000;
  background-color: rgb(248, 248, 248);
  margin: 0;
  padding: 0;
}

.swal2-container{
  z-index: 99999 !important;
}
</style>
